import { apiRoutes } from '../../constants/apiRoutes.ts';
import { useListApi } from '../../util/useListApi.tsx';
import { AspectRatio, Box, Image, Link, SimpleGrid } from '@chakra-ui/react';
import { Advertisement, AdvertisementPosition } from './types.ts';
import { useEffect, useState } from 'react';
import { useAdAspectRatio } from '../../util/useAdAspectRatio.ts';

type AdBannerProps = {
  numberOfAdsToDisplay: number;
  position: AdvertisementPosition;
};

export const AdBanner = (props: AdBannerProps) => {
  const numberOfAdsToDisplay = props.numberOfAdsToDisplay;
  const route = apiRoutes.crm.advertisements.base;
  const aspectRatio = useAdAspectRatio(props.position);
  const api = useListApi<Advertisement>('Advertisement', route);
  const { data, isLoading, isError } = api.list(0, 1000, false); //todo remove pagination?

  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState<Advertisement[] | null>(null);

  useEffect(() => {
    if (data) {
      setImages(data.PagedRows.filter((ad) => ad.PositionId === props.position));
    }
  }, [data?.PagedRows]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (images && images.length > 0) {
        setCurrentIndex((prevIndex) => (prevIndex + numberOfAdsToDisplay) % images.length);
      }
    }, 30000);

    return () => clearInterval(interval); // Cleanup
  }, [images]);

  if (isLoading || isError || !images || images.length === 0) {
    return null;
  }

  const currentImages = [
    ...images.slice(currentIndex, currentIndex + numberOfAdsToDisplay),
    ...images.slice(0, Math.max(0, currentIndex + numberOfAdsToDisplay - images.length))
  ];

  return (
    <Box w='100%' mx='auto'>
      <SimpleGrid columns={numberOfAdsToDisplay} gap={4}>
        {currentImages.map((ad, index) => (
          <AspectRatio key={index} width={'100%'} ratio={aspectRatio}>
            <Link
              target='_blank'
              href={ad.Url}
              _hover={{ textDecoration: 'none' }} // Prevents default underline hover for the link
            >
              <Image
                boxSize='100%'
                src={ad.ImageUrl}
                alt={ad.Name}
                objectFit='cover'
                _hover={{ transform: 'scale(1.05)', transition: 'transform 0.3s ease-in-out' }}
              />
            </Link>
          </AspectRatio>
        ))}
      </SimpleGrid>
    </Box>
  );
};
